import { cn } from "@/utils/cn";

interface AvatarSkeletonProps {
  type: "round-1" | "round-2" | "square";
  className?: string;
}

const AvatarCardSkeleton = ({ type, className }: AvatarSkeletonProps) => {
  return (
    <div
      className={cn(
        {
          "group flex flex-col items-center justify-start gap-[0.938rem] ": type === "round-1",
          "flex flex-col gap-[0.625rem]  text-center": type === "square",
        },
        "group/card animate-pulse ",
        className,
      )}
    >
      <div
        className={cn(
          {
            "responsive-transition aspect-square w-full rounded-full object-cover object-center outline outline-[0.188rem] -outline-offset-[0.188rem] outline-transparent group-hover:outline-orange-1 group-active:outline-orange-1":
              type === "round-1",
            "aspect-square w-full rounded-[1.25rem] object-cover object-center": type === "square",
          },
          "bg-surface-bright",
        )}
      />
      <div>
        <p className={cn("bg-surface-bright h-4 w-[6.25rem]")}></p>
      </div>
    </div>
  );
};

export default AvatarCardSkeleton;
